import { Form } from 'factorial-form'

export class VariableValueForm extends Form {
  constructor(values: {}) {
    super(values, {
      name: 'string',
      type: 'string',
      default_value: 'string',
      value: 'string',
    })
  }
}
